import { render } from "./Archaic.vue?vue&type=template&id=0133afae"
import script from "./Archaic.vue?vue&type=script&lang=js"
export * from "./Archaic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__